import type React from 'react';
import { DefaultV2 } from '~/components/common/layouts/DefaultV2';
import { ClientSettingLayout } from '~/components/common/layouts/settings/ClientSettingLayout';
import { NotificationSetting } from '~/components/specifics/settings/notifications/NotificationSetting';

export const Page: React.FC = () => (
  <DefaultV2>
    <ClientSettingLayout>
      <NotificationSetting />
    </ClientSettingLayout>
  </DefaultV2>
);
